"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ROUTE = void 0;
var ROUTE = {
  ELITE_BENEFITS: '/elitebenefits',
  EVENTS: '/events',
  HELP: '/help',
  HOME: '/home',
  INTERESTS_LIST_LIKES: '/interests/list/likes',
  INTERESTS_VIEWS: '/interests/views',
  INTERESTS: '/interests',
  LOGIN: '/login',
  LOGOUT: '/logout',
  MATCHPHONE_PHONEBOOK: '/phonebook',
  MESSAGES: '/messages',
  MUTUAL_INBOX: '/matches?tab=matches',
  PROFILE_EDIT: '/profile/me/edit',
  PROFILE_EDIT_CERTIFICATES: '/profile/me/edit?section=certificates',
  REACTIVATE: '/reactivate',
  SAFETY_CENTER: '/safetycenter/:slug?',
  SEARCH_MUTUAL: '/search/mutual',
  SEARCH_REVERSE: '/search/reverse',
  SEARCH_SAVED: '/search/saved/list',
  SEARCH: '/search',
  SETTINGS: '/user/settings',
  SUBSCRIBE_BOOST: '/subscribe/offers/topspot',
  SUBSCRIBE_POWER_UP: '/subscribe/addons/?lid=1&II=1',
  SUBSCRIBE_PREMIUM_BENEFITS: '/premiumbenefits',
  SUBSCRIBE: '/subscribe?areaId=21',
  UPGRADE_TO_PREMIUM_BILLING: '/subscription/upgrade-to-premium?areaId=8'
};
exports.ROUTE = ROUTE;